import { render, staticRenderFns } from "./CBtnAccion.vue?vue&type=template&id=94622fb4&"
import script from "./CBtnAccion.vue?vue&type=script&lang=js&"
export * from "./CBtnAccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports